import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/auto-verkaufen/wir-kaufen-dein-auto/Wirkaufendeinauto.js");
